import Alert from "../../assets/icons/alert.png";
import Button from "../ui/button";

type PropType = {
  setIsVendor: () => void;
  onContinue: () => void;
};

const ResetCart = ({ onContinue, setIsVendor }: PropType) => {
  return (
    <div className="fixed flex flex-col w-full h-full z-[2147483019] scrollbar-thin bg-trans5  inset-0  transition-opacity">
      <div className="relative  bg-white mt-auto md:my-[5%] mx-auto w-full md:w-[600px] rounded-lg">
        <div className="p-6 flex items-center flex-col gap-5 w-full">
          <img src={Alert} alt="" className="w-[15%]" />
          <div className="text-center text-sm md:text-base">
            Are you sure you want to switch to another restaurant? This action
            would clear your cart
          </div>
          <div className="flex gap-3 items-center w-full">
            <Button
              label="Cancel"
              loading={false}
              onClick={setIsVendor}
              color=""
            />
            <Button
              label="Continue"
              loading={false}
              onClick={onContinue}
              color="orange"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetCart;
